import { Component } from 'react';
import { RouterProps, withRouter } from 'react-router';
import { compose } from 'recompose';
import { BI_ERRORS, errorLogger } from '../../services/loggers/errorLogger';
import { RouteBuilder } from '../../utils/RouteHelpers';

// compose here is just to fix typescript
export const ErrorCatcher = compose(withRouter)(
  class ErrorCatcher extends Component<RouterProps> {
    state = {};

    static getDerivedStateFromError() {
      return {};
    }

    componentDidCatch(error) {
      errorLogger.log(BI_ERRORS.general.unknown, { reason: error });

      this.props.history.replace(RouteBuilder.UnknownError());
    }

    render() {
      return this.props.children;
    }
  },
);
